import { roomStatus } from '@/helpers'

export const session = ({ session }) => session

export const page = ({ session }) => Object.assign({}, session.page)

export const restoringSession = ({ restoringSession }) => restoringSession

export const externalLogin = ({ session }) => session.externalLogin

export const flux = ({ flux }) => flux

export const kbEnabled = ({ flux }) => flux && flux.kb && flux.kb.enabled

export const hasWaitingMessage = ({ flux }) =>
  flux && flux.rules && flux.rules.some(r => r.type === 'waiting-message')

export const waitingMessageDelay = ({ flux }) => {
  if (hasWaitingMessage({ flux })) {
    const waitingMessage = flux.rules.find(r => r.type === 'waiting-message')

    return waitingMessage.conditions[0].value * 1000
  }
}

export const waitingRuleExecuted = ({ flux }, { chat }) => {
  const waitingMessage =
    flux && flux.rules && flux.rules.find(r => r.type === 'waiting-message')

  return (
    chat &&
    waitingMessage &&
    chat.executedRules.some(
      r => r._id === waitingMessage._id || r.id === waitingMessage.id
    )
  )
}

export const fluxId = ({ flux }) => (flux ? flux.id : undefined)

export const fluxFormId = ({ flux }) => (flux ? flux.formId : '')

export const fluxSurvey = ({ flux }) => (flux ? flux.survey : undefined)

export const fluxForm = ({ flux }) =>
  flux && flux.form ? flux.form : undefined

export const hasProactiveMsgSender = ({ flux }) => {
  if (flux && flux.message && flux.message.sender && flux.message.sender.id) {
    return true
  } else {
    return false
  }
}

export const isSurveyAnswered = (_, { chatSurvey, surveyFinished }) =>
  chatSurvey && chatSurvey.response && surveyFinished

export const canAskSurvey = (
  _,
  { fluxSurvey, chatStatus, chat, chatSurvey, isSurveyAnswered }
) => {
  const result =
    fluxSurvey &&
    fluxSurvey.enabled &&
    chatStatus === roomStatus.closed &&
    chat &&
    chat.agent &&
    chat.closed &&
    chat.closed.typeReason !== 'inactivity' &&
    chatSurvey &&
    !isSurveyAnswered

  return !!result
}

export const inBotFlux = ({ flux }) => !!(flux && flux.botId)

export const surveyFinished = ({ surveyFinished }) => surveyFinished
